<template>
	<div class="road-block">
		<modal
			:size="$store.getters.layout == 'Desktop' ? 'auto' : 'max'"
			:show="showModal"
			:positionCloseX="'right'"
			:disableOutSideClick="false"
			:showCloseButton="true"
			:className="'road-block-banner-modal'"
			@close="showModal = false"
		>
			<template slot="modal-content">
				<div @close="showModal = false">
					<div class="road-block__container" @click="openLink">
						<img
							v-if="imageUrl"
							:src="imageUrl"
							:alt="'App Promo'"
							class="road-block__container__artwork"
						/>

						<div class="road-block__container__content" v-if="title">
							<h2>{{ title }}</h2>
							<p v-if="desc">{{ desc }}</p>
						</div>
						<div class="road-block__container__actions" v-if="showCTAs">
							<a
								:class="'road-block__container__actions__btn ' + btnStyle"
								:href="hrefBtn.link"
								@click.native="showModal = false"
								v-if="Object.keys(hrefBtn).length !== 0"
							>
								{{ hrefBtn.title }}
							</a>
							<router-link
								v-if="Object.keys(routerBtn).length !== 0"
								:class="'road-block__container__actions__btn ' + btnStyle"
								:to="routerBtn.path"
								@click.native="showModal = false"
							>
								{{ routerBtn.title }}
							</router-link>
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>
<script>
export default {
	props: {
		imageUrl: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: false,
			default: null,
		},
		desc: {
			type: String,
			required: false,
			default: null,
		},
		showCTAs: {
			type: Boolean,
			default: false,
			required: true,
		},
		hrefBtn: {
			type: Object,
			default: () => ({}),
			required: false,
		},
		routerBtn: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		btnStyle: {
			type: String,
			required: false,
			default: "block",
		},
		roadblockLink: {
			type: String,
			required: false,
			default: null,
		},
	},
	data() {
		return { showModal: false };
	},
	watch: {
		showModal(v) {
			if (!v) {
				const storeTodaysDate = (date = "") =>
					localStorage.setItem(
						"showRoadBlockBannerModal",
						JSON.stringify(date)
					);
				storeTodaysDate(new Date().toLocaleDateString());
			}
		},
	},
	mounted() {
		let vm = this;
		console.log(vm.roadblockLink);
		localStorage.getItem("showRoadBlockBannerModal") !== null
			? (vm.showModal =
					JSON.parse(localStorage.getItem("showRoadBlockBannerModal")) !==
					new Date().toLocaleDateString())
			: (vm.showModal = true);
		localStorage.setItem(
			"showRoadBlockBannerModal",
			JSON.stringify(new Date().toLocaleDateString())
		);
	},
	methods: {
		openLink() {
			let vm = this;
			vm.showModal = false;
			vm.$router.push(vm.roadblockLink);
		},
	},
};
</script>
<style lang="scss">
.road-block {
	&__container {
		&__artwork {
			width: 100%;
			//max-width: 400px;
		}
		text-align: center;
		&__content {
			h2 {
				font-size: var(--font-massive);
				font-weight: var(--font-weight-normal);
				color: var(--active-state);
				margin-bottom: 0;
			}
			p {
				color: var(--non-active-state);
				font-weight: var(--font-weight-lighter);
				margin-top: 5px;
			}
		}
		&__actions {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 8px;

			&__btn {
				width: 100%;
				border-radius: 4px;
				cursor: pointer;
				padding: 10px 15px;
				text-decoration: none;
				font-size: var(--font-normal);
				font-weight: var(--font-weight-medium);
				margin-top: 15px;
				&.block {
					background: var(--green);
					color: var(--always-white);
				}
				&.light {
					background: var(--color-primary-lightest, #f5ffe9);
					color: var(--color-primary-primary, #60981a);
				}
			}
		}
	}
}
.road-block-banner-modal {
	.modal__container {
		padding: 0;
		background-color: transparent;
	}
	.modal__x {
		right: -18px;
		left: auto;
		top: -22px;
		font-size: 35px;
		background-color: var(--active-state);
		color: var(--black-dark-10);
		padding: 0;
		padding-bottom: 5px;
		border-radius: 50%;
		line-height: 0;
	}
}
</style>
